import React from "react";
import { useNavigate } from "react-router-dom";
import { getLoanStateColor, showLoanStatusMessage } from "../../utils/loan";
import { formatDate, formatMoneyNumber } from "../../utils/util";
import Geometry from "../ui/Geometry/Geometry";
import HStack from "../ui/Stack/HStack";
import styles from "./loan-card-style.module.css";
import { useTranslation } from "react-i18next";

const LoanCard = ({ loan }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('loanCard');
  const navigateLoanDetail = () => {
    navigate(`/my-loans/${loan.loan_id}`);
  };

  const isLoanPending = loan.loan_state === "draft";

  const isMou = loan?.mou_status === "approve";

  return (
    <div className={styles.container}>
      <HStack style={{ marginBottom: 10 }} gap={1.5} align="center">
        <Geometry.Circle
          size={7}
          style={{
            backgroundColor:
              loan.loan_state && getLoanStateColor(loan.loan_state),
          }}
        />
        <h2 style={{ fontSize: 16, color: getLoanStateColor(loan.loan_state) }}>
          {showLoanStatusMessage(loan.loan_state)}
        </h2>
      </HStack>

      <div className={styles.content}>
        <div className={styles.row}>
          <span className={styles.label}>
            {isLoanPending ? t('loanItem') : t('loanId')}
          </span>
          <span className={styles.value}>{loan.loan_name}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>{t('loanName')}</span>
          <span className={styles.value}>
            {loan.product_name} {isMou && "(MOU)"}
          </span>
        </div>

        {loan.vehicle_type && (
          <div className={styles.row}>
            <span className={styles.label}>{t('vehicleType')}</span>
            <span className={styles.value}>
              {loan.vehicle_type === "sedan" ? "รถเก๋ง" : loan.vehicle_type === "van" ? "รถตู้" : loan.vehicle_type === "suv" ? "รถ SUV" : loan.vehicle_type}
            </span>
          </div>
        )}

        <div className={styles.row}>
          <span className={styles.label}>{t('limit')}</span>
          <span className={styles.amount}>
            {parseFloat(loan.loan_amount)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </span>
        </div>

        {/* <div className={styles.row}>
          <span className={styles.label}>ชำระแล้ว</span>
          <span className={styles.amount}>
            {formatMoneyNumber(totalPaid)} (+{totalInterest.toFixed(2)})
          </span>
        </div> */}

        <div className={styles.row}>
          <span className={styles.label}>{t('debtLeft')}</span>
          <span className={styles.amount}>
            {formatMoneyNumber(loan.remaining_amount)}
          </span>
        </div>

        <span className={styles.date}>
          {t('at')} {formatDate(new Date())}
        </span>
      </div>

      <div className={styles.details}>
        <button className={styles.detailsButton} onClick={navigateLoanDetail}>
          {t('detail')}
        </button>
      </div>
    </div>
  );
};

export default LoanCard;
